
import { createApp } from "vue";
import App from "./App.vue";
import store from "./store";
import ElementPlus from "element-plus";
import "element-plus/dist/index.css";
import "bootstrap-icons/font/bootstrap-icons.css";
import router from "./router";
import VueTilt from "vue-tilt.js";
import "./assets/css/nucleo-icons.css";
import "./assets/css/nucleo-svg.css";
import VueSweetalert2 from "vue-sweetalert2";
import SoftUIDashboard from "./medical";
import { initTheme } from "./project/Source/theme";
import { Chart, registerables } from "chart.js";

Chart.register(...registerables);
initTheme();

function updateCssVariables() {
  const domain = window.location.hostname;
  const root = document.documentElement;

  if (domain === "medical-hp.progress-ims.com") {
    root.style.setProperty("--info-color", "#a72923");
  } else {
    root.style.setProperty("--info-color", "#E83229");
  }
}
updateCssVariables();

const appInstance = createApp(App);
appInstance.use(store);
appInstance.use(router);
appInstance.use(ElementPlus);
appInstance.use(VueTilt);
appInstance.use(VueSweetalert2);
appInstance.use(SoftUIDashboard);
appInstance.mount("#app");

